import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { withFirebase } from 'react-redux-firebase'
import { withStyles } from '@material-ui/core/styles'
import { compose } from 'redux'
import { withRouter } from 'react-router-dom'
import { styles } from '../containers/dockPadStyle'
import classNames from 'classnames'
import DockPadChip from './DockPadChips'
import { LookAheadStatuses } from '../containers/helpers/AllTasksScreen'

class DockPadPillSelector extends Component {
  onClick(status, disabled) {
    if (!!disabled) return

    const { onValueChange } = this.props
    onValueChange(status)
  }
  renderStatusPill(status, disabled, color) {
    const { classes, value } = this.props
    if (!!disabled) return

    return (
      <div
        onClick={this.onClick.bind(this, status, disabled)}
        className={classNames(classes.LookAheadStatusPill)}>
        <DockPadChip
          disabled={disabled}
          variant={value === status ? color : 'nonselected'}
          label={status}
        />
      </div>
    )
  }
  render() {
    const { classes, hasLookahead } = this.props

    return (
      <div className={classNames(classes.LookAheadStatusContainer)}>
        {this.renderStatusPill(
          LookAheadStatuses.OPEN,
          !!hasLookahead,
          'yellow'
        )}
        {this.renderStatusPill(LookAheadStatuses.COMMITTED, false, 'blue')}
        {this.renderStatusPill(
          LookAheadStatuses.COMPLETE,
          !hasLookahead,
          'green'
        )}
        {this.renderStatusPill(
          LookAheadStatuses.INCOMPLETE,
          !hasLookahead,
          'red'
        )}
      </div>
    )
  }
}
DockPadPillSelector.propTypes = {
  value: PropTypes.string.isRequired,
  onValueChange: PropTypes.func.isRequired,
  hasLookahead: PropTypes.bool.isRequired
}

export default compose(
  withRouter,
  withFirebase,
  withStyles(styles, { withTheme: true })
)(DockPadPillSelector)



// WEBPACK FOOTER //
// ./src/components/DockPadPillSelector.tsx